import get from 'lodash/get';

export default function selector(storeState) {
    const audienceSegments = get(storeState, 'brandVisitationDashboard.audienceSegments');
    const totalSegmentCount = get(storeState, 'brandVisitationDashboard.totalSegmentCount');
    const isLoading = get(storeState, 'brandVisitationDashboard.isLoading');
    const organizationId = get(storeState, 'profile.organizationId');

    return {
        audienceSegments,
        totalSegmentCount,
        isLoading,
        organizationId,
    };
}
